import React, {useMemo} from "react"
import {makeStyles, createStyles} from "@material-ui/core/styles"

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      webkitAnimation: `$spinner 2s infinite ease`,
      animation: `$spinner 2s infinite ease`,
      margin: `100px auto`,
      width: 240,
      height: 240,
    },
    loader: {
      position: `absolute`,
      width: 240,
      height: 240,
      borderRadius: 240,
      border: `8px solid dodgerblue`,
      borderRightColor: `transparent`,
      webkitAnimation: `$spinner 2s infinite linear`,
      animation: `$spinner 2s infinite linear`,
    },
    "@keyframes spinner": {
      "0%": {
        webkitTransform: `rotate(0deg), opacity: 0.4`,
        transform: `rotate(0deg), opacity: 0.4`,
      },
      "50%": {
        webkitTransform: `rotate(180deg), opacity: 1.0`,
        transform: `rotate(180deg), opacity: 1.0`,
      },
      "100%": {
        webkitTransform: `rotate(360deg), opacity: 0.4`,
        transform: `rotate(360deg), opacity: 0.4`,
      },
    },
    "@keyframes loader": {
      "0%": {
        webkitTransform: `rotate(0deg)`,
        transform: `rotate(0deg)`,
      },
      "100%": {
        webkitTransform: `rotate(360deg)`,
        transform: `rotate(360deg)`,
      },
    },
    // "@keyframes spinner": {
    //   "0%": {},
    //   "100%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,1)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.2)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.5)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.7)`],
    //   },
    //   "12.5%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.7)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,1)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.2)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.5)`],
    //   },
    //   "25%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.5)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.7)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,1)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.2)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.2)`],
    //   },
    //   "37.5%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.2)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.5)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.7)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,1)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.2)`],
    //   },
    //   "50%": {
    //   boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.2)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.5)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.7)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,1)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.2)`],
    //   },
    //   "62.5%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.2)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.5)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.7)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,1)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.2)`],
    //   },
    //   "75%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.2)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.2)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.5)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.7)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,1)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,0.2)`],
    //   },
    //   "87.5%": {
    //     boxShadow: [`0em -2.6em 0em 0em rgba(#fafafa,0.2)`,
    //     `1.8em -1.8em 0 0em rgba(#fafafa,0.2)`,
    //     `2.5em 0em 0 0em rgba(#fafafa,0.2)`,
    //     `1.75em 1.75em 0 0em rgba(#fafafa,0.2)`,
    //     `0em 2.5em 0 0em rgba(#fafafa,0.2)`,
    //     `-1.8em 1.8em 0 0em rgba(#fafafa,0.5)`,
    //     `-2.6em 0em 0 0em rgba(#fafafa,0.7)`,
    //     `-1.8em -1.8em 0 0em rgba(#fafafa,1)`],
    //   },
    // },
  }),
)

export default function Spinner() {
  const classes = useStyles()
  return useMemo(
    () => (
      <div className={classes.root}>
        <div className={classes.loader} />
      </div>
    ),
    [classes],
  )
}
